import { EUROPACE_PAYMENT_DATES } from 'cpool-constants';
import { z } from 'zod';

import { schemaBigDecimal, schemaInteger } from '../../../utils/schema.utils';

export const schemaEuropaceFinanzierungswunsch = z.object({
    kreditbetrag: z.optional(schemaBigDecimal),
    laufzeitInMonaten: z.optional(schemaInteger),
    provisionswunschInProzent: z.optional(schemaBigDecimal),
    rateMonatlich: z.optional(schemaBigDecimal),
    ratenzahlungstermin: z.optional(z.nativeEnum(EUROPACE_PAYMENT_DATES)),
});

export type SchemaEuropaceFinanzierungswunsch = z.infer<typeof schemaEuropaceFinanzierungswunsch>;
